import image from "./images"
const ownerData = [
    {

        ownerImg: image.saifali,
        ownerName: "Saifali",
        ownercontact: "3737373737",
        ownerwhatsapp: "7575757575",
        ownerEmail: "saifali2021@iic.ac.in",
        ownerFacebook: "xyz_abc",
        aboutPet: "Gracie is super friendly and active. She loves people and other dogs and is always happy to meet them. She is great with kids which makes her a wonderful companion."


    },
    {

        ownerImg: image.saifali,
        ownerName: "Zain",
        ownercontact: "3737373737",
        ownerwhatsapp: "7575757575",
        ownerEmail: "abcd@gmail.com",
        ownerFacebook: "xyz_abc",
        aboutPet: "Gracie is super friendly and active. She loves people and other dogs and is always happy to meet them. She is great with kids which makes her a wonderful companion."
    },
    {

        ownerImg: image.saifali,
        ownerName: "Saifali",
        ownercontact: "3737373737",
        ownerwhatsapp: "7575757575",
        ownerEmail: "saifali2021@iic.ac.in",
        ownerFacebook: "xyz_abc",
        aboutPet: "Gracie is super friendly and active. She loves people and other dogs and is always happy to meet them. She is great with kids which makes her a wonderful companion."
    },
    {

        ownerImg: image.saifali,
        ownerName: "Saifali",
        ownercontact: "3737373737",
        ownerwhatsapp: "7575757575",
        ownerEmail: "saifali2021@iic.ac.in",
        ownerFacebook: "xyz_abc",
        aboutPet: "Gracie is super friendly and active. She loves people and other dogs and is always happy to meet them. She is great with kids which makes her a wonderful companion."
    },


];

export default ownerData;